
import { defineComponent, onMounted, ref } from 'vue';
import { PositionBaseResponse } from '@/core/interfaces/ApiResponses';
import { useRouterCustom } from '../../../../core/hooks/use-router-custom';
import { swalErrNotification } from '../../../../core/helpers/utils';
import { usePageHeader } from '@/core/hooks/usePageHeader';

import PositionTable from '@/views/crafted/pages/positions/position-table/PositionTable.vue';
import ChucVuService from '@/core/services/ChucVu.service';
import PageContentBase from '../../../../layout/_shared/PageContentBase.vue';

export default defineComponent({
  name: 'positions-index',
  components: { PositionTable, PageContentBase },
  setup() {
    const { push } = useRouterCustom();
    const positions = ref<PositionBaseResponse[]>([]);

    usePageHeader({
      title: 'Danh sách chức vụ',
      breadcrumbs: [{ text: 'Chức vụ' }],
      addLabel: 'Thêm chức vụ',
      onAdd: () => push('/quan-ly/chuc-vu/tao-moi'),
    });

    const loadPositions = async () => {
      positions.value = await ChucVuService.listForSelect();
    };

    onMounted(async () => {
      try {
        await loadPositions();
      } catch (e) {
        swalErrNotification(
          e,
          'Xin lỗi, có vẻ có lỗi xảy khi lấy thông tin chức vụ, mời bạn quay lại sau'
        );
      }
    });

    const onDeleteButtonClickedHandler = async (id: number) => {
      try {
        await ChucVuService.delete(id);
        await loadPositions();
      } catch (e) {
        swalErrNotification(
          e,
          'Xin lỗi, có vẻ có lỗi xảy khi lấy xóa chức vụ này, mời bạn thao tác lại sau'
        );
      }
    };

    return {
      positions,
      onDeleteButtonClickedHandler,
    };
  },
});
